window.addEventListener('load', () => {
  const klaviyoBISOpenTrigger = document.querySelector('.klaviyo-bis-trigger');
  if (!klaviyoBISOpenTrigger) return;

  klaviyoBISOpenTrigger.addEventListener('click', modalBackInStockInit);

  function modalBackInStockInit() {

    const targetNode = document.getElementById("klaviyo-bis-iframe");
    const config = { attributes: true, childList: true, subtree: true };

    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) if (mutation.type === "attributes") modalBackInStockIsLoaded();
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);


    function modalBackInStockIsLoaded() {

      const klaviyoIframeEl = document.querySelector('iframe#klaviyo-bis-iframe');
      const klaviyoIframe = klaviyoIframeEl.contentDocument;
      const submitBIS = klaviyoIframe.querySelector('.submit-container');
      const emailInput = klaviyoIframe?.querySelector('#email');
      const errorMessageEmail = klaviyoIframe?.querySelector('#error_message');

      if (klaviyoIframeEl.style.display == '') document.querySelector('body').style.overflow = 'hidden';
      else document.querySelector('body').style.overflow = 'auto';

      const emailWrapper = emailInput.closest('.col-sm-12');
      emailWrapper.append(errorMessageEmail);

      if (!errorMessageEmail || !submitBIS || !emailInput || !errorMessageEmail) return;

      errorMessageEmail.innerText = '';
      errorMessageEmail.innerText = window.languages.error_message_klaviyo;

      function emailValidator(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
      };

      emailInput?.addEventListener('input', (e) => handleEmailValidation(e));
      submitBIS.addEventListener('click', (e) => handleEmailValidation(e))

      function handleEmailValidation(e) {
        const isEmailValid = emailValidator(emailInput.value);
        if (!isEmailValid) {
          e.preventDefault();
          emailInput.style.borderColor = 'red';
          errorMessageEmail.style.display = 'block';
        } else {
          emailInput.style.borderColor = '#294634'
          errorMessageEmail.style.display = 'none';

        }
      }
    }
  }
})

